// extracted by mini-css-extract-plugin
module.exports = {"labelAndButtonWrapper":"gZLMk6bM"};